import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { SurveysBySpecialistRow } from '../surveys-by-specialist-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<SurveysBySpecialistRow> {

	return {
		rowName: { singular: 'Specialist Response', plural: 'Specialist Responses' },
		getRowKey: row => '' + row.accSessionSpecialistSurveyResponseId,
		stateKey: 'accelerator-surveys-by-specialist-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
